import React from 'react';
import moment from "moment";
import { ErrorMessage } from './Step1Setup/Components/ErrorMessage';
import RegexMap from '../../../utils/regexMap';
import { ErrLength } from './Step2LegacyOptions/Components/styles.js';
import { ErrMargin, MarginWrapper } from './Step2LegacyOptions/styles.js';
import regexMap from '../../../utils/regexMap';

const mandatoryFieldsForStep1 = [
	'firstname',
	'lastname',
	'gender',
	'dob',
	'ssn',
	'confirmSSN',
	'deliveryMethod',
	'emails',
	'phones',
	'addresses',
	'relatedDonor',
];

function inputBlurValidation(value, key) {
	switch (key) {
		case 'firstname':
		case 'lastname':
		case 'gender':
		case 'dob':
		case 'ssn':
		case 'confirmSSN':
		case 'deliveryMethod':
			if (!value) return false;
			return true;
		case 'emailId':
			if (RegexMap.emailRegEx.test(value)) {
				return true;
			}
			return false;
		default:
			return true;
	}
}

const checkForAdvisor = ({firstname,lastname,dob} ,val) => {
	if(firstname === val.firstName && lastname === val.lastName && dob === moment(val.dob).format("MM/DD/YYYY")){
		return true;
	} 
	 return false;
}

/*
	Handling Errors, checking if any field is falling under Error State
	@params step number, step related data
*/
export const ErrorHandling = (step, data, finalCheck = false, psAdvisor = {}) => {
	let finalErrorState = [];
	let userTochedAccordion = [];
	/* Step = 1 [step 1 - provide information] */
	if (step === 1) {
		/* Looping through the data for both primary Advisor And Secondary Advisor */
		data.forEach((part, i) => {
			let { fields, errors } = part;
			/* Checking for the mandatory fields in Advisor Tab */
			mandatoryFieldsForStep1.forEach((keys, index) => {
				/** Just to check whether that field exists for advisors */
				switch (keys) {
					case 'relatedDonor':
						/** This is to check for contributor fields only in Primary Advisor */
						if (!i) {
							fields[keys] &&
								fields[keys].forEach((contributorObj, contributorIndex) => {
									if (!contributorObj['name']) {
										errors['name'] = {
											...errors['name'],
											[contributorIndex]: ErrorMessage('name'),
										};
									}
									if (!contributorObj['relationship']) {
										errors['relationshipType'] = {
											...errors['relationshipType'],
											[contributorIndex]: ErrorMessage('relationshipType'),
										};
									}
								});
						}
						break;
					case 'addresses':
						/* For Address Fields */
						fields[keys] &&
							fields[keys].forEach((addressObj, addressIndex) => {
								if (!addressObj['addresstype']) {
									errors['addressType'] = {
										...errors['addressType'],
										[addressIndex]: ErrorMessage('addressType'),
									};
								}
								if (!addressObj['line1']) {
									errors['line1'] = {
										...errors['line1'],
										[addressIndex]: ErrorMessage('line1'),
									};
								}
								if (!addressObj['city']) {
									errors['city'] = {
										...errors['city'],
										[addressIndex]: ErrorMessage('city'),
									};
								}
								if (!addressObj['state']) {
									errors['state'] = {
										...errors['state'],
										[addressIndex]: ErrorMessage('state'),
									};
								}
								if (!addressObj['zipcode']) {
									errors['zipcode'] = {
										...errors['zipcode'],
										[addressIndex]: ErrorMessage('zipcode'),
									};
								}
							});
						break;
					case 'emails':
						/* For Email Fields */
						fields[keys] &&
							fields[keys].forEach((emailObj, emailIndex) => {
								if (!emailObj['emailtype']) {
									errors['emailType'] = {
										...errors['emailType'],
										[emailIndex]: ErrorMessage('emailType'),
									};
								}
								//Checking for null or empty data only
								if (!emailObj['emailId']) {
									errors['emailId'] = {
										...errors['emailId'],
										[emailIndex]: ErrorMessage('emailId'),
									};
								} else {
									// Checking for email Format
									if (!inputBlurValidation(emailObj['emailId'], 'emailId')) {
										errors['emailId'] = {
											...errors['emailId'],
											[emailIndex]: ErrorMessage('emailId', 'format'),
										};
									}
								}
							});
						break;
					case 'phones':
						/* For Phone Fields */
						fields[keys] &&
							fields[keys].forEach((phoneObj, phoneIndex) => {
								if (!phoneObj['phonetype']) {
									errors['phoneType'] = {
										...errors['phoneType'],
										[phoneIndex]: ErrorMessage('phoneType'),
									};
								}
								if (!phoneObj['phonenumber']) {
									errors['phones'] = {
										...errors['phones'],
										[phoneIndex]: ErrorMessage('phones'),
									};
								}
							});
						break;
					case 'confirmSSN':
						/* For Static Fields */
						if (i === 1 && !inputBlurValidation(fields[keys], keys)) {
							errors[keys] = {
								...errors[keys],
								[1]: ErrorMessage(keys),
							};
						}
						break;
					default:
						/* For Static Fields */
						if (!inputBlurValidation(fields[keys], keys)) {
							errors[keys] = {
								...errors[keys],
								[1]: ErrorMessage(keys),
							};
						}
						break;
				}
			});
			finalErrorState[i] = errors;
		});
	} else {
		/* Step = 2 [step 2 - Legacy Options] */
		let { fundName, legacyOptions } = data;

		/** Validating Fund Name */
		let fundNameArr = [];
		if (fundName) {
			let lowerCaseFundName = fundName.toLowerCase();
			/** Checking for The and Fund in the account name */
			let trimName = fundName.trim();
			fundNameArr = trimName.split(' ');
			(fundNameArr[0].toLowerCase() === 'the' || fundNameArr[fundNameArr.length - 1].toLowerCase() === 'fund') &&
				finalErrorState.push({
					accountNameError: <ErrLength>Remove the word "The" and "Fund"</ErrLength>,
				});
			/** Checking for correct account format name */
			fundName.length >= 2 && !RegexMap.AccountNameRegEx.test(fundName) &&
				finalErrorState.push({
					accountNameError: <ErrLength>Please use at least two letters or two numbers.</ErrLength>,
				});
			/** Checking if the account name is less than 2 characters */
			fundName.length < 2 &&
				finalErrorState.push({
					accountNameError: <ErrLength>Account name is too short. Please try again.</ErrLength>,
				});

			/** Checking For Special Characters */	
			let errorContent = 'The following special characters are not allowed : |, <, >.';
			regexMap.eliminateSpecialCharacter.test(fundName) &&
				finalErrorState.push({
					accountNameError: <ErrLength>{errorContent}</ErrLength>
				});

			/** Checking for the following words in the name */
			(lowerCaseFundName.includes('trust') ||
				lowerCaseFundName.includes('endowment') ||
				lowerCaseFundName.includes('foundation')) &&
				finalErrorState.push({
					accountNameError: (
						<ErrLength>
							Account name cannot use the words 'trust', 'endowment' or 'foundation'. Please try again.
						</ErrLength>
					),
				});
		} else {
			finalErrorState.push({
				accountNameError: <ErrLength>Please enter account name</ErrLength>,
			});
		}

		/** Checking for Successors Fields [This block of code will validate all the successor fields]*/
		if (finalCheck) {
			legacyOptions.forEach((legacy, index) => {
				let tabIndexError = [];
				
				legacy.validateAdvisor = '';
				if (legacy.successorAdvisor && legacy.percentage) {
					!legacy.percentage && (legacy.percentageError = <ErrMargin>Please enter percentage</ErrMargin>);
					let advisors = legacy.successorAdvisor.successorAdvisor;
					if (index === 0 || index === 1) {
						advisors.forEach((advisor, i) => {
							let temp = 0;
							if (!advisor.firstName) {
								advisor.firstNameError = <ErrMargin>Please enter first name</ErrMargin>;
								temp++;
							}
							if(psAdvisor.primary && (checkForAdvisor(psAdvisor.primary,advisor) || checkForAdvisor(psAdvisor.secondary,advisor))) {
								temp++;
								tabIndexError.push((i + 1));
								legacy.duplicateAdvisorError = {
									status: true,
									advTab: 'The successor advisor ',
									index: tabIndexError,
									msg: 'cannot match an existing account advisor. Please select another successor advisor.',
									contentKey: legacy.optionId 
								};
							}  

							if(advisor.duplicateError){
								temp++;
							}
							if (!advisor.lastName) {
								advisor.lastNameError = <ErrMargin>Please enter last name</ErrMargin>;
								temp++;
							}
							if (!advisor.relationshipType) {
								advisor.relationshipTypeError = (
									<ErrMargin>Please enter your relation to account advisor</ErrMargin>
								);
								temp++;
							}
							if (!advisor.dob) {
								advisor.dobError = <ErrMargin>Please enter the date of birth</ErrMargin>;
								temp++;
							}
							if (!advisor.gender) {
								advisor.genderError = <ErrMargin>Please enter the gender</ErrMargin>;
								temp++;
							}
							if (!advisor.address.line1) {
								advisor.address.line1Error = <ErrMargin>Please enter address</ErrMargin>;
								temp++;
							}
							if (advisor.address.country === "0" && !advisor.address.state) {
								advisor.address.line1Error = <ErrMargin>Please enter state</ErrMargin>;
								temp++;
							}
							if (!advisor.address.city) {
								advisor.address.cityError = <ErrMargin>Please enter city</ErrMargin>;
								temp++;
							}
							if (!advisor.address.zip) {
								advisor.address.zipError = <ErrMargin>Please enter Zip Code</ErrMargin>;
								temp++;
							}
							if (temp !== 0) {
								legacy[`validateAdvisor${i}`] = false;
							} else {
								legacy[`validateAdvisor${i}`] = true;
								if (advisors.length === 1) {
									legacy[`validateAdvisor`] = true;
									delete legacy[`validateAdvisor${i}`];
									legacy.duplicateAdvisorError = {
										status: false,
										advTab: null,
										msg: null,
										index: [],
										contentKey: null 
									};
								}
							}
							if (i !== 0) {
								if (
									legacy[`validateAdvisor${i - 1}`] &&
									legacy[`validateAdvisor${i}`] &&
									legacy.validateAdvisor !== false
								) {
									legacy.validateAdvisor = true;
									userTochedAccordion = [{ true: index }, ...userTochedAccordion];
									legacy.duplicateAdvisorError = {
										status: false,
										advTab: null,
										msg: null,
										index: [],
										contentKey: null 
									};
								} else {
									legacy.validateAdvisor = false;
									userTochedAccordion = [{ false: index }, ...userTochedAccordion];
								}
								if (advisors.length === i + 1) {
									delete legacy[`validateAdvisor${i}`];
								}
								delete legacy[`validateAdvisor${i - 1}`];
							}
						});
					} else if (index === 3) {
						let percent = 0;
						advisors.forEach((advisor, i) => {
							let temp = 0;
							if (!advisor.name) {
								advisor.charityNameError = <ErrMargin>Please enter first name</ErrMargin>;
								temp++;
							}
							if (!advisor.charityAllocPercent) {
								advisor.charityAllocPercentError = <ErrMargin>Please enter % of charity</ErrMargin>;
								temp++;
							} else {
								percent += parseInt(advisor.charityAllocPercent);
							}
							if (!advisor.grantRecognition) {
								advisor.grantRecognitionError = <ErrMargin>Grant recognition required</ErrMargin>;
								temp++;
							}
							if (!advisor.grantPurpose) {
								advisor.otherGrantPurposeTextError = <ErrMargin>Grant purpose required</ErrMargin>;
								temp++;
							}
							if (advisor.grantPurpose === 'OTHER' && !advisor.otherGrantPurposeText) {
								advisor.otherGrantPurposeTextError = <ErrMargin>Grant purpose required</ErrMargin>;
								temp++;
							}
							if (!advisor.address.line1) {
								advisor.address.line1Error = <ErrMargin>Please enter address</ErrMargin>;
								temp++;
							}
							if (advisor.address.country === "0" && !advisor.address.state) {
								advisor.address.line1Error = <ErrMargin>Please enter state</ErrMargin>;
								temp++;
							}
							if (!advisor.address.city) {
								advisor.address.cityError = <ErrMargin>Please enter city</ErrMargin>;
								temp++;
							}
							if (!advisor.address.zip) {
								advisor.address.zipError = <ErrMargin>Please enter Zip Code</ErrMargin>;
								temp++;
							}
							if (temp !== 0) {
								legacy[`validateAdvisor${i}`] = false;
							} else {
								if (advisors.length === i + 1) {
									if (percent === 100) {
										legacy[`validateAdvisor${i}`] = true;
									} else {
										advisor.multipleCharitiesError = (
											<MarginWrapper><ErrMargin>Total percentage should be 100%</ErrMargin></MarginWrapper>
										);
										legacy[`validateAdvisor${i}`] = false;
									}
								} else {
									legacy[`validateAdvisor${i}`] = true;
								}
							}
							if (advisors.length === 1) {
								if(legacy[`validateAdvisor${i}`]){
									legacy[`validateAdvisor`] = true;
								}else{
									legacy[`validateAdvisor`] = false;
								}
								delete legacy[`validateAdvisor${i}`];
							}
							if (i !== 0) {
								if (
									legacy[`validateAdvisor${i - 1}`] &&
									legacy[`validateAdvisor${i}`] &&
									legacy.validateAdvisor !== false
								) {
									legacy.validateAdvisor = true;
									userTochedAccordion = [{ true: index }, ...userTochedAccordion];
								} else {
									legacy.validateAdvisor = false;
									userTochedAccordion = [{ false: index }, ...userTochedAccordion];
								}
								if (advisors.length === i + 1) {
									delete legacy[`validateAdvisor${i}`];
								}
								delete legacy[`validateAdvisor${i - 1}`];
							}
						});
					}
				}
			});
			finalErrorState.push(legacyOptions);
		}
	}

	if (finalCheck) {
		return { userTochedAccordion, finalErrorState };
	} else {
		return finalErrorState;
	}
};
